import React from 'react';

export const GreaterThanEqualsIcon = React.forwardRef(function Compliance(
  props: React.ComponentProps<'svg'>,
  ref: React.ForwardedRef<SVGSVGElement>,
) {
  return (
    <svg
      id="Layer_1"
      height="512"
      viewBox="0 0 512 512"
      width="512"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth="2"
      fill="currentColor"
      {...props}
      ref={ref}
    >
      <g>
        <g>
          <path d="m176.3 288.6 135.5-62.4-135.5-62.4c-4.2-1.9-6.9-6.2-6.9-10.8v-.4c0-8.7 9.1-14.5 17-10.7l147 69.6c5.6 2.7 9.2 8.3 9.2 14.6 0 6.2-3.6 11.9-9.2 14.6l-147 69.6c-7.9 3.7-17-2-17-10.7 0-4.9 2.7-9.1 6.9-11zm5.9 57.2h147.6c7.1 0 12.8 5.7 12.8 12.8 0 7.1-5.7 12.8-12.8 12.8h-147.6c-7.1 0-12.8-5.7-12.8-12.8 0-7.1 5.7-12.8 12.8-12.8z" />
        </g>
      </g>
    </svg>
  );
});
